<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
@media screen and (max-width:359px) {
    html {
        font-size:85px
    }
}
@media screen and (min-width:360px) and (max-width:374px) {
    html {
        font-size:90px
    }
}
@media screen and (min-width:375px) and (max-width:413px) {
    html {
        font-size:100px
    }
}
@media screen and (min-width:414px) {
    html {
        font-size:110px
    }
}

body{
  margin:0;
  background:   #f0f1f5;
  font-size: 16px;
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html,body,#app {
    height: 100%;
    // overflow: hidden;
    background:   #f0f1f5;
}
a, abbr, acronym, address, applet, article, aside, audio, b, big, blockquote, body, canvas, caption, center, cite, code, dd, del, details, dfn, div, dl, dt, em, embed, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, menu, nav, object, ol, output, p, pre, q, ruby, s, samp, section, small, span, strike, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, tt, u, ul, var, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
}
a {
    -webkit-user-drag: none;
    text-decoration: none;
    color: inherit;
}
a, button, div, header, input, label, p, span, table, td, textarea, tr {
    -webkit-tap-highlight-color: rgba(255,255,255,0);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.wrap-scroll {
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    // overflow-scrolling: touch;
}
.mint-radio-core {
   display: inline-block;
}
.mint-radio-input:checked + .mint-radio-core::after {
    background-color: transparent;
    -webkit-transform: scale(1);
     border-color:#fff;
     transform: rotate(45deg) scale(1);
}
.mint-radio-core::after {
    border-radius: 0;
    border: 2px solid transparent;
    border-left: 0;
    border-top: 0;
    content: " ";
    top: 3px;
    left: 6px;
    position: absolute;
    width: 4px;
    height: 8px;
    -webkit-transform: rotate(45deg) scale(0);
    transform: rotate(45deg) scale(0);
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
}
.mint-radiolist-title{
    margin:0;
}
h3{
    font-weight: normal;
}
.page-loadmore-wrapper {
  display: flex;
  flex-direction: column;
  .mint-loadmore {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    .mint-loadmore-content {
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      .mint-loadmore-top,.mint-loadmore-bottom {
        span {
          display: inline-block;
          transition: 0.2s linear;
          vertical-align: middle;
          &.is-rotate {
            transform: rotate(180deg);
          }
        }
      }
      .page-loadmore-list {
          flex: 1 0 auto;
      }
      .nothing {
          flex: 1 0 auto;
      }
    }
  }
}

.icon {
  background-position:  center center;
  background-repeat:    no-repeat;
  background-size:      contain;
}
.logo {
  width:      45px;
  height:     45px;
  background-image: url('./assets/logo.png');
}
.add-icon {
  width:      36px;
  height:     36px;
  background-image: url('./assets/add.png');
}
.bind-icon {
  width:      48px;
  height:     20px;
  background-image: url('./assets/bind.png');
}
.cancel-icon {
  width:      14px;
  height:     14px;
  background-image: url('./assets/cancel.png');
}
.createWallet-icon {
  width:      180px;
  height:     180px;
  background-image: url('./assets/createWallet.png');
}

.copyright {
    font-size:  10px;
    color:      #97a4b8;
    text-align: center;
}

///////////////////////////////////////////

.black {
  color: #222;
}
.grey {
  color: #999;
}
.blue {
  color: #41a3ff;
}
.small {
  font-size: 12px;
}
.tiny {
  font-size: 10px;
}
.big {
  font-size: 16px;
}
.bold {
  font-weight: bold;
}

.small-title {
  padding:  12px 15px;
  .small;
  background:   transparent;
  .grey;
  .bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue